import { Avatar, Box, Button, Divider, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { LogOut } from 'react-feather';
import { useAuth } from '../../../authentication/useAuth';
import IconButtonWithMenu from '../../../components/IconButtonWithMenu';
import { tokens } from '../../../theme';

// The release version, set by release/build-release.ps1; a dev server shows 'development'
const version = process.env.REACT_APP_VERSION || 'development';

// Who is signed in, where, and on which version, with Sign out
const ProfileButton = ({ ...rest }) => {
    const [open, setOpen] = useState(false);
    const { user, logout } = useAuth();
    const site = JSON.parse(localStorage.getItem('selectedSite'));
    const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.userName || 'User';
    const initials = name.split(' ').filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
    const avatar = (size) => (
        <Avatar sx={{ width: size, height: size, fontSize: size * 0.4, fontWeight: 600, bgcolor: tokens.accent, color: tokens.navy }}>{initials}</Avatar>
    );

    return (
        <IconButtonWithMenu open={open} onClick={() => setOpen((v) => !v)} onMenuClose={() => setOpen(false)} Icon={avatar(32)} aria-label={`Account: ${name}`} {...rest}>
            <Stack spacing={1.5} sx={{ width: 260 }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    {avatar(44)}
                    <Box minWidth={0}>
                        <Typography fontWeight={700} noWrap>{name}</Typography>
                        <Typography variant="body2" color="text.secondary" noWrap>{user?.roleDescription ?? user?.role}</Typography>
                    </Box>
                </Stack>
                <Divider />
                <Box>
                    <Typography variant="body2" color="text.secondary">Site</Typography>
                    <Typography variant="body2" fontWeight={600}>{site?.siteName ?? 'None chosen'}{site?.siteCode ? ` (${site.siteCode})` : ''}</Typography>
                </Box>
                <Box>
                    <Typography variant="body2" color="text.secondary">Version</Typography>
                    <Typography variant="body2" fontWeight={600}>{version}</Typography>
                </Box>
                <Divider />
                <Button variant="outlined" color="error" startIcon={<LogOut size={16} />} onClick={logout}>Sign out</Button>
            </Stack>
        </IconButtonWithMenu>
    );
};

export default ProfileButton;
